"use client";

import React from "react";
import { Info } from "lucide-react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const teamMembers = [{
  id: 1,
  name: "Sophie van der Berg",
  role: "Eigenaresse & Master Stylist",
  bio: "Met meer dan 15 jaar ervaring in het vak creëert Sophie meesterwerken die perfect passen bij de unieke persoonlijkheid en gezichtsvorm van haar klanten.",
  favoriteColor: "Zandbeige",
  portraitImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/sophie_portrait.png",
  actionImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/sophie_action.png"
}, {
  id: 2,
  name: "Emma de Vries",
  role: "Senior Stylist & Kleurspecialist",
  bio: "Emma is onze expert op het gebied van Balayage en complexe kleurtechnieken. Ze heeft een feilloos oog voor detail en natuurlijke nuances.",
  favoriteColor: "Karamel",
  portraitImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/emma_portrait.png",
  actionImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/emma_action.png"
}, {
  id: 3,
  name: "Julian Bakker",
  role: "Top Stylist & Herenspecialist",
  bio: "Gespecialiseerd in zowel klassieke herensnitten als moderne styling. Julian zorgt ervoor dat elke man de salon met een zelfverzekerd gevoel verlaat.",
  favoriteColor: "Diepzwart",
  portraitImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/julian_portrait.png",
  actionImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/julian_action.png"
}, {
  id: 4,
  name: "Lisa Smit",
  role: "Junior Stylist & Styling Expert",
  bio: "Lisa brengt een frisse blik en is een talent in volumineuze blow-outs en elegante opsteekkapsels voor bruiloften en speciale gelegenheden.",
  favoriteColor: "Parelmoer",
  portraitImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/lisa_portrait.png",
  actionImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1620688/img/lisa_action.png"
}];
export default function MeetThePainters() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="129809" id="ontmoet-de-experts" className="bg-background py-24 lg:py-32">
      <div className="container mx-auto px-6 md:px-12">
        <div ref={ref} className={`mb-16 text-center transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <h2 className="font-serif text-4xl tracking-tight text-foreground md:text-5xl lg:text-6xl">
            Ontmoet de Experts
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-lg text-muted-foreground">
            Een gepassioneerd team van professionals staat klaar om jouw haarwensen te vervullen. 
            Beweeg over de foto's om ons in actie te zien.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2 lg:grid-cols-4">
          {teamMembers.map((member, i) => <div key={member.id} data-index={i} className={`group flex flex-col transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <div className="relative mb-6 aspect-[3/4] w-full overflow-hidden rounded-xl bg-muted shadow-md">
                <img src={member.portraitImg} alt={`${member.name} portret`} className="absolute inset-0 h-full w-full object-cover transition-opacity duration-700 ease-in-out group-hover:opacity-0" />
                <img src={member.actionImg} alt={`${member.name} aan het werk`} className="absolute inset-0 h-full w-full object-cover opacity-0 transition-opacity duration-700 ease-in-out group-hover:opacity-100" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
              </div>

              <div className="flex items-start justify-between px-2">
                <div>
                  <h3 className="font-sans text-lg font-medium text-foreground">{member.name}</h3>
                  <p className="text-sm font-normal text-muted-foreground">{member.role}</p>
                </div>
                <HoverCard>
                  <HoverCardTrigger asChild>
                    <button className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary/5 text-secondary transition-colors hover:bg-primary hover:text-primary-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2" aria-label={`Meer informatie over ${member.name}`}>
                      <Info className="h-4 w-4" />
                    </button>
                  </HoverCardTrigger>
                  <HoverCardContent align="end" sideOffset={8} className="w-72 border-border/50 bg-card p-5 shadow-xl backdrop-blur-xl">
                    <div className="space-y-3">
                      <h4 className="font-serif text-lg text-foreground">{member.name}</h4>
                      <p className="text-sm leading-relaxed text-muted-foreground">
                        {member.bio}
                      </p>
                      <div className="pt-3 border-t border-border/50">
                        <p className="text-xs font-medium text-foreground">
                          Favoriete Tint: <span className="text-primary">{member.favoriteColor}</span>
                        </p>
                      </div>
                    </div>
                  </HoverCardContent>
                </HoverCard>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}